import styled from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  user-select: none;
  margin: 0 .5rem;
  width: 450px;
  max-width: 450px;
  box-sizing: border-box;
  @media ${devices.phoneS} {
    max-width: auto;
  }
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
`;

export const InputColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
`;

export const InputContainer = styled.div`
  padding: 5px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.container};
  & .input-text-line-wrapper * {
    background-color: transparent !important;
  }
  & .no-timeout-checkbox {
    & label {
      padding: 0;
    }
    & .box {
      margin-right: 5px;
    }
  }
`;
